import React from 'react';
import { NuqsAdapter } from 'nuqs/adapters/react-router/v6';
import { Outlet } from 'react-router-dom';

/**
 * declare and import to the specific version of nuqs
 * https://nuqs.47ng.com/docs/adapters#react-router-v6
 */

export function NuqsAdapterContext(): JSX.Element {
  return (
    <NuqsAdapter>
      <Outlet />
    </NuqsAdapter>
  );
}

export default NuqsAdapterContext;

/**
 * You can enable debug logs in the browser by setting the following in the browser console and reload the page.
 * https://nuqs.47ng.com/docs/debugging
 * localStorage.setItem('debug', 'nuqs')
 */
